export const isPixExpired = (expiration: Date | null, now: Date): boolean =>
  expiration != null ? expiration.getTime() < now.getTime() : false;
